import { atomFamily } from 'jotai-family';
import { atomWithSessionStorage } from './atomEffects';

/**
 * Per-interaction unlock timestamp (ms since epoch), persisted to session
 * storage. `null` means the interaction is locked (the default for a
 * terminal-status interaction). A timestamp means the user unlocked it; the
 * unlock expires one week later (see `INTERACTION_UNLOCK_DURATION_WEEKS`),
 * after which the interaction reverts to locked.
 */
export const interactionUnlockedAtState = atomFamily((interactionId: string) =>
  atomWithSessionStorage<number | null>(
    `interactionUnlockedAt:${interactionId}`,
    null,
  ),
);
